import React from "react";
import Icon from "@ant-design/icons";

const BellHalfFilledSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    stroke="none"
  >
    <path
      fill="#165ABF"
      d="M2.9 9.738C3.48 8.805 4 7.394 4 5.334c0-.397.059-.788.172-1.161l7.161 7.161h-7.74c-.798 0-1.197 0-1.285-.066-.098-.072-.124-.119-.134-.24-.009-.11.236-.503.726-1.29z"
    ></path>
    <path
      stroke="#165ABF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.333 14H6.667M5.755 2.024A4 4 0 0112 5.334c0 1.4.18 2.5.432 3.355m-8.26-4.517A3.999 3.999 0 004 5.334c0 2.06-.52 3.47-1.1 4.404-.49.787-.735 1.18-.726 1.29.01.121.036.168.134.24.088.066.487.066 1.285.066h7.74M14 14.001L2 2"
    ></path>
  </svg>
);

const BellHalfFilledIcon = (props) => (
  <Icon component={BellHalfFilledSvg} {...props} />
);

export { BellHalfFilledIcon };
